import { languageHelper } from "../../../config/helperFunctions";
import React from "react";
// import { useNavigate } from "react-router-dom";

function SmsModuleForm() {
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">{languageHelper("Twilio sms")}</h1>
          </div>
        </div>
        <label htmlFor="" className="w-full md:w-2/3">
          <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
            {languageHelper("Status")}
          </span>

          <div className="mb-2 pt-0">
            <input
              className="form-check-input pb-3"
              type="radio"
              name="exampleRadios"
              id="exampleRadios1"
              value="option1"
              checked
            />
            <label
              className="form-check-label pe-5 ps-3 text-[#7B20C7] text-sm mb-2 "
              for="exampleRadios1"
            >
              {languageHelper("Active")}
            </label>
            <input
              className="ps-5"
              type="radio"
              name="exampleRadios"
              id="exampleRadios2"
              value="option2"
            />
            <label
              className="form-check-label ps-3 text-[#7B20C7] text-sm mb-2"
              for="exampleRadios2"
            >
              {languageHelper("Inactive")}
            </label>
          </div>
        </label>

        <div className="w-full">
          <form
            action=""
            className="w-full"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Token")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Token")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Server Id")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Server Id")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2  relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Message Service Id")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" Message Service Id"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full pt-2">
              <label htmlFor="" className="w-full md:w-2/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Template")}
                </span>
                <div className="text-red-500">
                  Customer_name, Restaurant_name, Restaurant_number,
                  Order_number,
                </div>
                <div className="mb-2 pt-3">
                  <textarea
                    type="text"
                    placeholder=""
                    rows={6}
                    className="p-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full md:w-1/3"></label>
            </div>
            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                {languageHelper("Submit")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default SmsModuleForm;
